export const colors = {
  white: "#FFFFFF",
  lightGray: "#F6F6F6",
  black: "#000000",
  primary: "#339CFF", // SkipGive blue
  gold: "#339CFF", // Legacy - same as primary
  error: "red",
  blueLink: "#6990e6",
};
